/**
 * @flow
 * @relayHash 497522d686720644b030585b5d495d4f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ReturnOrderStatus = "AUTHORIZED" | "CLOSED" | "RECEIVED" | "REJECTED" | "REQUESTED";
export type ReturnReason = "CUSTOMER_CHANGED_MIND" | "DAMAGED" | "DEFECTIVE" | "NOT_AS_DESCRIBED" | "OTHER" | "WRONG_ITEM";
export type ReturnType = "CREDIT" | "REFUND" | "REPAIR" | "REPLACEMENT";
export type UpdateReturnOrderInput = {|
  id: string,
  status?: ?ReturnOrderStatus,
  returnType?: ?ReturnType,
  reason?: ?ReturnReason,
  notes?: ?string,
  customerNotes?: ?string,
|};
export type UpdateReturnOrderMutationVariables = {|
  input: UpdateReturnOrderInput
|};
export type UpdateReturnOrderMutationResponse = {|
  +updateReturnOrder: {|
    +returnOrderEdge: {|
      +node: {|
        +id: string,
        +returnNumber: string,
        +status: ReturnOrderStatus,
        +returnType: ?ReturnType,
        +reason: ?ReturnReason,
        +authorizedDate: ?any,
        +receivedDate: ?any,
        +notes: ?string,
        +customerNotes: ?string,
        +order: ?{|
          +id: string,
          +orderNumber: string,
        |},
        +customer: {|
          +id: string,
          +name: string,
        |},
        +updatedAt: any,
        +createdAt: any,
      |}
    |}
  |}
|};
export type UpdateReturnOrderMutation = {|
  variables: UpdateReturnOrderMutationVariables,
  response: UpdateReturnOrderMutationResponse,
|};
*/


/*
mutation UpdateReturnOrderMutation(
  $input: UpdateReturnOrderInput!
) {
  updateReturnOrder(input: $input) {
    returnOrderEdge {
      node {
        id
        returnNumber
        status
        returnType
        reason
        authorizedDate
        receivedDate
        notes
        customerNotes
        order {
          id
          orderNumber
        }
        customer {
          id
          name
        }
        updatedAt
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateReturnOrderInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateReturnOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateReturnOrderPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "returnOrderEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "ReturnOrderEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ReturnOrder",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "returnNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "returnType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "reason",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "authorizedDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "receivedDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customerNotes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderNumber",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "customer",
                "storageKey": null,
                "args": null,
                "concreteType": "Customer",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateReturnOrderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateReturnOrderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateReturnOrderMutation",
    "id": null,
    "text": "mutation UpdateReturnOrderMutation(\n  $input: UpdateReturnOrderInput!\n) {\n  updateReturnOrder(input: $input) {\n    returnOrderEdge {\n      node {\n        id\n        returnNumber\n        status\n        returnType\n        reason\n        authorizedDate\n        receivedDate\n        notes\n        customerNotes\n        order {\n          id\n          orderNumber\n        }\n        customer {\n          id\n          name\n        }\n        updatedAt\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8194c54817e86f07e639f019c0c9572f';
module.exports = node;
